import { useEffect } from 'react';

export const usePushNotifications = () => {
  useEffect(() => {
    const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
    
    if (isIOS) {
      const isStandalone = (window.navigator as any).standalone === true;
      const isPWA = window.matchMedia('(display-mode: standalone)').matches;
      
      if (!isStandalone && !isPWA) {
        console.log('🍎 iOS Safari: Push notifications no disponibles');
        console.log('💡 Sugerencia: Añadir a pantalla de inicio para PWA');
        return; // ✅ SALIR TEMPRANO - NO HACER NADA EN iOS SAFARI
      }
    }


    const setupPush = async () => {
      try {
        // Verificaciones básicas
        if (!('serviceWorker' in navigator) || 
            !('PushManager' in window) || 
            !('Notification' in window)) {
          console.log('📱 Push notifications no soportadas en este dispositivo');
          return;
        }

        // Verificar permisos existentes
        if (Notification.permission === 'granted') {
          console.log('✅ Permisos ya concedidos');
          // Aquí podrías verificar/actualizar suscripción existente
        } else {
          console.log('🔔 Permisos de notificación no concedidos');
        }
      } catch (error) {
        console.warn('⚠️ Error configurando push notifications:', error);
      }
    };

    setupPush();
  }, []);
};